export function useConfirmData() {
  return {
    aterExclusiveServiceMunicipality:
      localStorage.getItem('aterExclusiveServiceMunicipality') ?? '0',
    aterServiceByMunicipalPartner:
      localStorage.getItem('aterServiceByMunicipalPartner') === 'true',
    aterMunicipalPartnerList: JSON.parse(
      localStorage.getItem('aterMunicipalPartnerList') ?? '[]',
    ),

    municipalProvided: localStorage.getItem('municipal_provided') ?? '0',
    municipalApplied: localStorage.getItem('municipal_applied') ?? '0',
    municipalCnpjProducts: JSON.parse(
      localStorage.getItem('municipal_cnpjProducts') ?? '[]',
    ),
    municipalCpfProducts: JSON.parse(
      localStorage.getItem('municipal_cpfProducts') ?? '[]',
    ),

    stateProvided: localStorage.getItem('state_provided') ?? '0',
    stateApplied: localStorage.getItem('state_applied') ?? '0',
    stateCnpjProducts: JSON.parse(
      localStorage.getItem('state_cnpjProducts') ?? '[]',
    ),
    stateCpfProducts: JSON.parse(
      localStorage.getItem('state_cpfProducts') ?? '[]',
    ),

    federalProvided: localStorage.getItem('federal_provided') ?? '0',
    federalApplied: localStorage.getItem('federal_applied') ?? '0',
    federalCnpjProducts: JSON.parse(
      localStorage.getItem('federal_cnpjProducts') ?? '[]',
    ),
    federalCpfProducts: JSON.parse(
      localStorage.getItem('federal_cpfProducts') ?? '[]',
    ),
  };
}
